export default "__VITE_ASSET__D$gHb$Ot__"